module.exports = __webpack_public_path__ + "img/ic-transaction-history.f1f95638.svg";